// extracted by mini-css-extract-plugin
export var infoWrapper = "n_b7";
export var label = "n_b8";
export var title = "n_bq";
export var subtitle = "n_b9";
export var price = "n_b5";
export var priceTagCn = "n_cb";
export var priceTag = "n_cc";
export var originalPriceTag = "n_cd";
export var labelView = "n_cf";
export var visible = "n_cg";
export var labelItemGroup = "n_ch";
export var labelItem = "n_cj";
export var colors = "n_ck";
export var colorsMain = "n_cl";
export var unavailable = "n_cm";
export var active = "n_bk";
export var sizes = "n_cn";
export var sizesMain = "n_cp";
export var property = "n_cq";
export var commitment = "n_cr";
export var commitmentGroup = "n_cs";
export var service = "n_ct";
export var serviceGroup = "n_cv";
export var qrWrap = "n_cw";